var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mostrarBtn)?_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmar()}}},[_c('span',[_c('i',{staticClass:"fa fa-check-circle-o"}),_vm._v(" Comunicar conclusão ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }